import { ReactElement } from 'react'
import type { ProductReviews } from '@pylot-data/pylotschema'
import s from './ReviewsDesktop.module.scss'
import ReviewRatings from './ReviewRatings/ReviewRatings'
import ReviewComments from './ReviewComments/ReviewComments'
import cn from 'classnames'

type ReviewsDesktopProps = {
    reviews: ProductReviews
    ratingSummary: number
    reviewCount: number
    sku: string
}

const ReviewsDesktop: React.FC<ReviewsDesktopProps> = ({
    reviews,
    ratingSummary,
    reviewCount,
    sku
}: ReviewsDesktopProps): ReactElement | null => {
    return (
        <div className={cn(s['review-layout-desk'])}>
            <ReviewRatings
                reviews={reviews}
                ratingSummary={ratingSummary}
                reviewCount={reviewCount}
            />
            <ReviewComments reviews={reviews} sku={sku} />
        </div>
    )
}

export default ReviewsDesktop
